import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const ServicesAndContacts = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 2 }}
      viewport={{ once: false, amount: 0.1 }}
      className="service container"
    >
      <div className="services">
        <h1>QUICK SERVICES</h1>
        <div className="services-links">
          <Link to="/apply" target="_blank" className="quick-links">
            APPLY NOW VIA AAS
          </Link>
          <Link to="/AGFA/apply" target="_blank" className="quick-links">
            APPLY NOW VIA AGFA
          </Link>
          <Link to="/aia/universities" target="_blank" className="quick-links">
            UNIVERSITIES
          </Link>
          <Link to="/news" target="_blank" className="quick-links">
            ANNOUNCEMENTS & UPDATES
          </Link>
          <Link to="https://www.tcu.go.tz/" className="quick-links" target="_blank">
            TCU
          </Link>
          <Link to="https://www.nactevet.go.tz/" className="quick-links" target="_blank">
            NACTEVET
          </Link>
        </div>

      </div>
      <div className="contact">
        <h1>CONTACT US</h1>
        <address>
          Dar es salaam, Tanzania
          <br />
          Tanzania: <a href="+255757001100">+255757001100</a>
          <br />
          China: <a href="tel:+8619572907062">+8619572907062</a>
          <br />
          <a href="mailto:arthurinternational0@gmail.com">
            arthurinternational0@gmail.com
          </a>
          <br />
        </address>
        <h1>TANZANIA OFFICE</h1>
        <address>
          PHAMIL HOUSE BUILDING 1st FLOOR ,OFFICE NO. 3<br />
          TANZANIA<br />
          DAR ES SALAAM, MWANANYAMALA
          <br />
          (Beside mwananyamala sokoni)
        </address>

        <h1>CHINA OFFICE 中国办公室</h1>
        <address>
          地址: 300学士路含浦岳麓区长沙湖南中国<br />
          Address: 300 Xueshi Lu,   <br />
          Hanpu Science & Education, <br />
          Yuelu District, <br />
          Changsha City, <br />
          Hunan China.
        </address>
      </div>
    </motion.div>
  );
};
